import comp from "./MediaModal";
export default comp;
